// src/constants/reportTableHeaders.js

import { formatCurrency } from "../../utils/utils";

export const expenseHeaders = [
  { key: "ExpenseCategory", label: "Category" },
  { key: "ExpenseSubcategory", label: "Subcategory" },
  { key: "Description", label: "Description" },
  { key: "VendorName", label: "Vendor" },
  {
    key: "TotalAmount",
    label: "Amount",
    align: "right",
    render: (row) => formatCurrency(row.TotalAmount),
  },
];

export const incomeHeaders = [
  { key: "IncomeCategory", label: "Category" },
  { key: "IncomeSubcategory", label: "Subcategory" },
  { key: "Description", label: "Description" },
  {
    key: "TotalAmount",
    label: "Amount",
    align: "right",
    render: (row) => formatCurrency(row.TotalAmount),
  },
];

export const mealHeaders = [
  {
    key: "MonthDate",
    label: "Date",
    render: (row) => row.MonthDate || "N/A",
  },
  {
    key: "Income.SchoolName",
    label: "Site",
  },
  {
    key: "Income.BR_Free",
    label: "Breakfast Free",
    align: "right",
  },
  {
    key: "Income.BR_Paid",
    label: "Breakfast Paid",
    align: "right",
  },
  {
    key: "Income.BR_Reduced",
    label: "Breakfast Reduced",
    align: "right",
  },
  {
    key: "Income.LN_Free",
    label: "Lunch Free",
    align: "right",
  },
  {
    key: "Income.LN_Paid",
    label: "Lunch Paid",
    align: "right",
  },
  {
    key: "Income.LN_Reduced",
    label: "Lunch Reduced",
    align: "right",
  },
  {
    key: "Income.SN_Free",
    label: "Snack Free",
    align: "right",
  },
  {
    key: "Income.SP_Free",
    label: "Supper Free",
    align: "right",
  },
  {
    key: "Summary_Total",
    label: "Total Sales",
    align: "right",
    render: (row) => formatCurrency(row.Summary_Total),
  },
];
